import { Button, SvgIcon } from '@mui/material';
import SmsIcon from 'assets/icons/phone-sms-icon.svg';
import Alert from 'components/alerts/Alert';
import ms from 'ms';
import { string } from 'prop-types';
import React, { useState } from 'react';
import Invite from 'services/api/Invite';
import { I18n } from 'utils/i18n';

const autoHideDuration = ms('10 seconds');

const InviteAgain = ({ employeeId }) => {
  const alertInitialState = { isOpen: false };
  const [alert, setAlert] = useState(alertInitialState);

  const onClose = () => {
    setAlert(a => ({ ...a, ...alertInitialState }));
  };

  const inviteAgain = () => {
    setAlert({
      isOpen: true,
      variant: 'success',
      message: I18n.t('ProfileDrawer.Invitation sent by sms'),
    });
    Invite.send(employeeId);
  };

  return (
    <>
      <Button
        onClick={inviteAgain}
        variant="outlined"
        disabled={alert.isOpen}
        color="secondary"
        startIcon={
          <SvgIcon sx={{ color: 'primary.main' }}>
            <SmsIcon />
          </SvgIcon>
        }
      >
        {I18n.t('ProfileDrawer.Invite again')}
      </Button>
      <Alert
        isOpen={alert.isOpen}
        variant={alert.variant}
        onClose={onClose}
        label={I18n.t('ProfileDrawer.Invite by sms')}
        caption={alert.caption}
        autoHideDuration={autoHideDuration}
      >
        {alert.message}
      </Alert>
    </>
  );
};

InviteAgain.propTypes = {
  employeeId: string.isRequired,
};

export default InviteAgain;
